const _removePIIFromUgc = (ugc: ContentBlob) => {
  if (
    ugc.ugctype === 'BrandMerchantResponse' ||
    ugc.ugctype === 'BrandAnswer' ||
    ugc.ugctype === 'SeededQuestion' ||
    ugc.ugctype === 'SeededAnswer'
  ) {
    return ugc;
  }

  const { location, author, ...rest } = ugc;
  return rest;
};

const removePIIFromUgc = (ugc: ContentBlob) => {
  return {
    ..._removePIIFromUgc(ugc),
    ugc_related_content: Array.isArray(ugc.ugc_related_content)
      ? ugc.ugc_related_content.map(_removePIIFromUgc)
      : ugc.ugc_related_content,
  };
};

export default removePIIFromUgc;



// WEBPACK FOOTER //
// ./src/containers/brand-engage/removePIIFromUgc.js